import { createElement } from "react";

export function getElement(html, querySelector){
    return html.querySelector(querySelector);
}

export function createOption(text, value){
    return createElement(
        'option',
        {text: text},
        {value: value}
    )
}